import { Chess } from 'chess.js';

// Color constants for arrows and highlighted squares
const COLOR_VARIANTS = {
  RED: "#ff0050",
  GREEN: "#58b047",
  BLUE: "#00F2EA",
  YELLOW: "#FFD700",
  BLACK: "#000000"
};

// Starting position FEN
const START_POSITION = new Chess().fen();

/**
 * Mock game data for testing the GameSummary component
 * Each game includes:
 * - creatorHandle: The username of the creator
 * - caption: A description of the game
 * - score: The game score (likes/rating)
 * - tags: Array of tags that match keys in the TAGS object from constants.js
 * - moves: Array of move objects with notation and optional arrows/highlightedSquares
 * - fen: Starting position FEN (defaults to standard starting position)
 */
const MOCK_GAMES = [
  {
    id: '1',
    creatorHandle: 'MagnusC',
    caption: 'Sicilian Defense Masterclass',
    score: 42,
    tags: ['Tactical', 'Master', 'Openings (W)'],
    fen: START_POSITION,
    moves: [
      {
        notation: 'e4',
        arrows: [["e2", "e4", COLOR_VARIANTS.BLUE]],
        highlightedSquares: {
          "e4": { backgroundColor: COLOR_VARIANTS.BLUE }
        }
      },
      { notation: 'c5' },
      { notation: 'Nf3' },
      { notation: 'd6' },
      { 
        notation: 'd4',
        arrows: [["d2", "d4", COLOR_VARIANTS.GREEN]],
        highlightedSquares: {
          "d4": { backgroundColor: COLOR_VARIANTS.GREEN }
        }
      },
      { notation: 'cxd4' },
      { notation: 'Nxd4' },
      { notation: 'Nf6' }
    ]
  },
  {
    id: '2',
    creatorHandle: 'Hikaru',
    caption: 'Queen\'s Gambit Declined - Instructive Endgame',
    score: 87,
    tags: ['Endgame', 'Positional', 'Classical'],
    fen: START_POSITION,
    moves: [
      { notation: 'd4' },
      { notation: 'd5' },
      { notation: 'c4' },
      { notation: 'e6' },
      { notation: 'Nc3' },
      { notation: 'Nf6' },
      { 
        notation: 'Bg5',
        arrows: [["c1", "g5", COLOR_VARIANTS.RED]],
        highlightedSquares: {
          "g5": { backgroundColor: COLOR_VARIANTS.RED }
        }
      },
      { notation: 'Be7' },
      { notation: 'e3' },
      { notation: 'O-O' },
      { notation: 'Qc2' }
    ]
  },
  {
    id: '3',
    creatorHandle: 'BethHarmon',
    caption: 'Stunning Queen Sacrifice!',
    score: 156,
    tags: ['Brilliance', 'Tactical', 'Blitz'],
    fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 4 4', // Italian Game position
    moves: [
      { notation: 'd4' },
      { notation: 'exd4' },
      { notation: 'Nxd4' },
      { notation: 'Nxd4' },
      { notation: 'Qxd4' },
      { 
        notation: 'Qh5+',
        arrows: [["d4", "h5", COLOR_VARIANTS.YELLOW]],
        highlightedSquares: {
          "h5": { backgroundColor: COLOR_VARIANTS.YELLOW },
          "g7": { backgroundColor: COLOR_VARIANTS.RED }
        }
      },
      { notation: 'g6' },
      { 
        notation: 'Qxg6+',
        arrows: [["h5", "g6", COLOR_VARIANTS.RED]],
        highlightedSquares: {
          "g6": { backgroundColor: COLOR_VARIANTS.RED },
          "h8": { backgroundColor: COLOR_VARIANTS.YELLOW }
        }
      },
      { notation: 'hxg6' },
      { notation: 'Bxf7#' }
    ]
  }
];

/**
 * Component to render multiple GameSummary components using the mock data
 * Usage example:
 * 
 * import { MOCK_GAMES } from '../util/mockGames';
 * 
 * // Render a single game
 * <GameSummary gameData={MOCK_GAMES[0]} onClick={() => console.log('Clicked')} />
 * 
 * // Render all games
 * {MOCK_GAMES.map((game, index) => (
 *   <GameSummary 
 *     key={game.id} 
 *     gameData={game} 
 *     onClick={() => console.log(`Clicked game ${index}`)} 
 *   />
 * ))}
 */

export default MOCK_GAMES; 